<template>
	<div v-loading="pageLoading">
		<h1>反饋問卷</h1>
		<div id="content">
			<ol>
				<li v-for="item in list" :key="item.id">
					<p>{{ item.content }}</p>
					<ol type="A">
						<li>{{ item.optionA }}</li>
						<li>{{ item.optionB }}</li>
						<li>{{ item.optionC }}</li>

						<li>{{ item.optionD }}</li>
					</ol>
				</li>
			</ol>
			<div v-for="(item,index) in questionList" :key="index">
				<p style="padding-left: 23px;">{{ list.length + (index+1) }}.{{ item }}</p>
				<el-input type="textarea" :rows="3" placeholder="请输入内容" disabled></el-input>
			</div>
		</div>
		<el-button class="btn" @click="$router.back(-1)">返 回</el-button>
	</div>
</template>

<script>
export default {
	data() {
		return {
			pageLoading: false,

			list: [],
			questionList:[],
			content: ''
		};
	},
	mounted() {
		$('#pageHead').text('反饋');
	},
	created() {
		var sectionId = sessionStorage.getItem('sectionId');
		var type = sessionStorage.getItem('courseType');
		this.pageLoading = true
		if (type == 'online') {
			this.axios({
				url: '/manage/getManOnlineSeeChapter',
				params: {
					id: sectionId
				}
			}).then(res => {
				var msg = res.result;
				for (var i = 0; i < msg.length; i++) {
					if (msg[i].contentType == 0) {
						this.list.push(msg[i]);
					} else {
						this.questionList.push(msg[i].content)
						// this.content = msg[i].content;
					}
				}
				this.pageLoading = false
			}).catch(() => {
				this.pageLoading = false
			})
		}else if(type=='offline'){
			this.axios({
				url: '/manage/getManOfflineSeeChapter',
				params: {
					id: sectionId
				}
			}).then(res => {
				var msg = res.result;
				for (var i = 0; i < msg.length; i++) {
					if (msg[i].contentType == 0) {
						this.list.push(msg[i]);
					} else {
						this.questionList.push(msg[i].content)
						// this.content = msg[i].content;
					}
				}
				this.pageLoading = false
			}).catch(() => {
				this.pageLoading = false
			})
		}else if(type=='live'){
			this.axios({
				url: '/manage/getManLiveSeeChapter',
				params: {
					id: sectionId
				}
			}).then(res => {
				var msg = res.result;
				for (var i = 0; i < msg.length; i++) {
					if (msg[i].contentType == 0) {
						this.list.push(msg[i]);
					} else {
						this.questionList.push(msg[i].content)
						// this.content = msg[i].content;
					}
				}
				this.pageLoading = false
			}).catch(() => {
				this.pageLoading = false
			})
		}
	}
};
</script>

<style scoped>
#content {
	padding: 20px;
	border: #000000 1px solid;
	border-radius: 5px;
}
.btn {
	position: absolute;
	top: 90px;
	right: 45px;
}
</style>
